import { render } from "./EntregasExcecaoView.vue?vue&type=template&id=0e052467&scoped=true"
import script from "./EntregasExcecaoView.vue?vue&type=script&lang=js"
export * from "./EntregasExcecaoView.vue?vue&type=script&lang=js"

import "./EntregasExcecaoView.vue?vue&type=style&index=0&id=0e052467&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD25\\Garantidoras\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e052467"]])

export default __exports__